import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getTokenAndFetchHeaders } from '../../utils';
import { apiRequest } from '../../utils/authConfig';
import { useMsal, account } from '../../utils/authContext';
import { ConstituentsByZipParams, ConstituentsParams, MailPullRequestProps, ParticipantsByChapterIdParams, PastEventRequestParams, ReportResponse, VolunteersParams } from '../types';
const api = process.env['REACT_APP_BACKEND_URL'];
const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';


export const SendMailPullRequest = (props: MailPullRequestProps) => {
    const navigate = useNavigate();
    const { getToken } = useMsal();
    const args = { ...apiRequest, account };
    const handlePastEventRequest = async () => {
        let error = false;
        let result: ReportResponse | undefined;
        if (!props.validate()) {
            return;
        }
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const body: PastEventRequestParams = {
            eventLookUpID: props.id,
            email: props.email,
            numYears: props.numberOfPriorEvents,
            includeCurrent: false,
            includeMinors: props.filters.includes("includeChildren"),
            sponsorsOnly: props.filters.includes("sponsorsOnly"),
        }
        const res = await fetch(`${api}/report/request/eventparticipantsbyevent`, {
            headers,
            method: 'POST',
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            error = true;
            result = {
                error: {
                    code: 'serverError',
                    message: 'There was an error processing your request.',
                }
            };
        } else {
            result = await res.json();
            if (result?.error) {
                error = true;
            }
        }
        navigate(`/event/mail-pull/result/${props.id}?status=${result?.message ? result.message : result?.error?.message}${error ? "&error=true" : ''}`);
    }
    const handleChapterRequest = async () => {
        let error = false;
        let result: ReportResponse | undefined;
        if (!props.validate()) {
            return;
        }
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const body: ParticipantsByChapterIdParams = {
            chapterId: props.id,
            email: props.email,
            numYears: props.numberOfPriorEvents,
            includeMinors: props.filters.includes("includeChildren"),
            sponsorsOnly: props.filters.includes("sponsorsOnly"),
        }
        const res = await fetch(`${api}/report/request/eventparticipantsbychapter`, {
            headers,
            method: 'POST',
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            error = true;
            result = {
                error: {
                    code: 'serverError',
                    message: 'There was an error processing your request.',
                }
            };
        } else {
            result = await res.json();
            if (result?.error) {
                error = true;
            }
        }
        navigate(`/event/mail-pull/result/${props.eventId}?status=${result?.message ? result.message : result?.error?.message}${error ? "&error=true" : ''}`);
    }
    const handleConstituentRequest = async () => {
        let error = false;
        let result: ReportResponse | undefined;
        if (!props.validate()) {
            return;
        }
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const body: ConstituentsParams = {
            chapterId: props.id,
            email: props.email,
            numYears: props.numberOfPriorEvents,
            orgType: props.orgType,
            includeMinors: props.filters.includes("includeChildren"),
            sponsorsOnly: props.filters.includes("sponsorsOnly"),
        }
        const res = await fetch(`${api}/report/request/generalconstituents`, {
            headers,
            method: 'POST',
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            error = true;
            result = {
                error: {
                    code: 'serverError',
                    message: 'There was an error processing your request.',
                }
            };
        } else {
            result = await res.json();
            if (result?.error) {
                error = true;
            }
        }
        navigate(`/event/mail-pull/result/${props.eventId}?status=${result?.message ? result.message : result?.error?.message}${error ? "&error=true" : ''}`);
    }
    const handleConstituentByZipRequest = async () => {
        let error = false;
        let result: ReportResponse | undefined;
        if (!props.validate()) {
            return;
        }
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const body: ConstituentsByZipParams = {
            zip: props.zip,
            email: props.email,
            numYears: props.numberOfPriorEvents,
            includeMinors: props.filters.includes("includeChildren"),
            sponsorsOnly: props.filters.includes("sponsorsOnly"),
        }
        const res = await fetch(`${api}/report/request/generalconstituentsbyzip`, {
            headers,
            method: 'POST',
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            error = true;
            result = {
                error: {
                    code: 'serverError',
                    message: 'There was an error processing your request.',
                }
            };
        } else {
            result = await res.json();
            if (result?.error) {
                error = true;
            }
        }
        navigate(`/event/mail-pull/result/${props.eventId}?status=${result?.message ? result.message : result?.error?.message}${error ? "&error=true" : ''}`);
    }
    const handleVolunteersRequest = async () => {
        let error = false;
        let result: ReportResponse | undefined;
        if (!props.validate()) {
            return;
        }
        const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
        const body: VolunteersParams = {
            chapterId: props.id,
            email: props.email,
            orgType: props.orgType,
            includeMinors: props.filters.includes("includeChildren"),
        }
        const res = await fetch(`${api}/report/request/volunteers`, {
            headers,
            method: 'POST',
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            error = true;
            result = {
                error: {
                    code: 'serverError',
                    message: 'There was an error processing your request.',
                }
            };
        } else {
            result = await res.json();
            if (result?.error) {
                error = true;
            }
        }
        navigate(`/event/mail-pull/result/${props.eventId}?status=${result?.message ? result.message : result?.error?.message}${error ? "&error=true" : ''}`);
    }
    return <>
        {props.contactType === 'pastEvent' && <Button onClick={handlePastEventRequest}>Request Report</Button>}
        {props.contactType === 'chapter' && <Button onClick={handleChapterRequest}>Request Report</Button>}
        {props.contactType === 'constituents' && <Button onClick={handleConstituentRequest}>Request Report</Button>}
        {props.contactType === 'zip' && <Button onClick={handleConstituentByZipRequest}>Request Report</Button>}
        {props.contactType === 'volunteers' && <Button onClick={handleVolunteersRequest}>Request Report</Button>}
    </>
}